<template>
  <div class="broadcast-ticket-item">
    <div class="info">
      <h3>{{ ticket.name }}</h3>
      <p class="desc" v-if="ticket.description">{{ ticket.description }}</p>
      <template v-if="ticket.expires_soon || ticket.expired">
        <p class="expiration-notice red">
          Ticket is expired or expires before broadcast starts
        </p>
      </template>
    </div>
    <div class="price">
      <p>{{ ticket.prices.length > 0 ? ticket.prices[0].formated_price : 'N/A' }}</p>
    </div>
    <div class="actions" v-if="removeable || add">
      <div class="remove red-hover" @click="removeTicket" v-if="removeable">
        <template v-if="removing">
          <i class="mdi mdi-loading mdi-spin" />
        </template>
        <template v-else>
          <i class="icon-trash1" />
        </template>
      </div>
      <div class="add" v-if="add && !ticket.expired && !ticket.expires_soon" @click="addTicket">
        <i class="icon-plusCircle blue" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ticket: {
      type: Object,
      required: true,
    },
    removeable: {
      type: Boolean,
      default: false,
    },
    add: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'broadcast',
      validator: value => ['broadcast', 'video'].indexOf(value) !== -1,
    },
  },
  computed: {
    /**
     * Return the current broadcast in store
     * @returns {?Object}
     */
    item() {
      if (this.type === 'video') {
        return this.$store.getters['Video/current'];
      }

      return this.$store.getters['Broadcast/current'];
    },
  },
  methods: {
    async removeTicket() {
      const {
        ticket: {
          id: ticketId,
        },
        item: {
          id: itemId,
        },
      } = this;
      await this.$store.dispatch('Products/deleteContent', { id: ticketId, payload: [`${this.type === 'video' ? 'video' : 'live'}:${itemId}`], patch: true });
      this.$store.dispatch('Products/getAllStreams');
    },
    async addTicket() {
      const {
        ticket: {
          id: ticketId,
        },
        item: {
          id: itemId,
        },
      } = this;
      await this.$store.dispatch('Products/updateContent', { id: ticketId, payload: [`${this.type === 'video' ? 'video' : 'live'}:${itemId}`], patch: true });
      this.$store.dispatch('Products/getAllStreams');
    },
  },
  data() {
    return {
      removing: false,
    };
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.broadcast-ticket-item {
  align-items: center;
  background: #FFFFFF;
  box-shadow: 0 2px 4px 0 rgba(165,179,194,0.20), 0 0 1px 0 rgba(165,179,194,0.50);
  border-radius: 4px;
  border: 1px solid #EEF0F9;
  display: flex;
  overflow: hidden;
  width: 100%;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }

  .info {
    flex: 1;
    padding: 16px 20px;
    overflow: hidden;

    h3 {
      font-size: 18px;
      line-height: 20px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .desc {
      color: #868B97;
      margin-top: 4px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .price {
    padding: 0 20px;
    p {
      font-size: 18px;
      line-height: 20px;
    }
  }

  .expiration-notice {
    color: var(--color-cta-red);
    margin-top: 4px;
  }
  .actions {
    align-self: stretch;
    display: flex;

    & > div {
      align-items: center;
      border-left: 1px solid #EEF0F9;
      display: flex;
      padding: 0 12px;
      transition: color .3s;

      &:hover {
        cursor: pointer;
      }
    }

    i {
      font-size: 20px;
    }

    .gray {
      color: var(--color-cta-gray);
      pointer-events: none;
    }

    .blue {
      color: var(--color-cta-blue);
    }

    .red {
      color: var(--color-cta-red);
    }

    .red-hover:hover {
      color: var(--color-cta-red);
    }
  }
}
</style>
